import { render } from "./index.vue?vue&type=template&id=4cd8a5dc"
import script from "./draggable-item.js?vue&type=script&lang=js"
export * from "./draggable-item.js?vue&type=script&lang=js"

import "./draggable-item.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "C:\\Users\\devin\\Desktop\\Web\\Portfolios\\Portolio\\vue-personal-portfolio\\portfolio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__